import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, message, Table} from 'antd';
import moment from 'moment';
import {Link} from 'react-router';
import {getIncCustomList} from '@store/modules/incubator/incu_custom_list';
import {queryCustomCanMoveOut, queryCustomMoveOut} from '@api/incubator/custom';
import ModalOut from './ModalOut';

class TabEnter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(
        item => nextProps.condition[item] !== this.props.condition[item],
      )
    ) {
      this.current = 1;
      this.condition = nextProps.condition;
      this.getIncCustomList();
    }
  }

  componentDidMount() {
    this.condition = this.props.condition;
    if (this.props.condition.incubatorUuid) {
      this.current = this.props.condition.residentCustomerCurrent || 1;
      this.pageSize = this.props.condition.residentCustomerPageSize || 10;
      this.getIncCustomList();
    }
  }

  getIncCustomList = () => {
    const pageSize = this.pageSize || 10;
    this.props.dispatch(
      getIncCustomList({
        ...this.condition,
        limit: pageSize,
        current: this.current,
        start: this.current,
        tab: 'residentCustomer',
      }),
    );
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getIncCustomList();
  };

  getTags = tags => {
    return tags.reduce((prev, curr) => `${prev + curr.name}、`, '');
  };

  confirm = params => {
    queryCustomMoveOut({
      uuid: this.currentCustom.uuid,
      ...params,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleResonVisible(false);
        this.getIncCustomList();
      } else {
        message.error(res.message);
      }
    });
  };

  handleClickOut = record => {
    const incubatorUuid = this.props.params.uuid;
    queryCustomCanMoveOut({
      incubatorUuid,
      customUuid: record.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        const { isMoveOut, isArchived } = res.data;
        !isMoveOut && !isArchived && message.error('暂时无法迁出，合同未归档，地址未迁出');
        isMoveOut && !isArchived && message.error('暂时无法迁出，合同未归档');
        !isMoveOut && isArchived && message.error('暂时无法迁出，地址未迁出');
        isMoveOut && isArchived && this.handleResonVisible(true, record);
      } else {
        message.error(res.message);
      }
    });
  };

  handleResonVisible = (flag, current) => {
    this.setState({
      resonVisible: !!flag,
    });
    this.currentCustom = current || {};
  };

  onSearch = params => {
    this.condition = params;
    this.current = 1;
    this.getIncCustomList();
  };

  columns = () => {
    const {
      condition: { incubatorUuid },
    } = this.props;
    return [
      {
        title: '公司名称',
        dataIndex: 'customName',
        key: 'customName',
        render: (text, record) => (
          <Link to={`/incubator/${incubatorUuid}/custom/detail/${record.customUuid}`}>{text}</Link>
        ),
      },
      {
        title: '联系人',
        dataIndex: 'contactName',
        key: 'contactName',
      },
      {
        title: '联系方式',
        dataIndex: 'contactTel',
        key: 'contactTel',
      },
      {
        title: '标签',
        dataIndex: 'tags',
        key: 'tags',
        render: (text, record) => <span>{this.getTags(record.tags)}</span>,
      },
      {
        title: '是否获得融资',
        dataIndex: 'isFinancing',
        key: 'isFinancing',
        render: text => {
          const string = text === 1 ? '是' : '否';
          return <span>{text ? string : ''}</span>;
        },
      },
      {
        title: '开始入驻时间',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '合同到期时间',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text, record) => {
          let day = 0;
          if (text) {
            day = Math.floor((Date.now() - text) / 86400000);
          }

          const element =
            day > 0 ? (
              <p style={{ color: 'red', marginBottom: '0' }}>（逾期{day}天）</p>
            ) : (
              <p style={{ marginBottom: '0' }}>（剩余{Math.abs(day)}天）</p>
            );
          return (
            <span>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'isMoveOut',
        render: (text, record) => <a onClick={() => this.handleClickOut(record)}>迁出</a>,
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.props;
    const { resonVisible } = this.state;
    return (
      <div>
        <Table
          rowKey="uuid"
          dataSource={list}
          loading={loading}
          pagination={pagination}
          columns={this.columns()}
          onChange={this.onTableChange}
        />
        <ModalOut
          visible={resonVisible}
          handleOk={this.confirm}
          handleCancel={this.handleResonVisible}
        />
      </div>
    );
  }
}

export default connect(state => ({
  dataSource: state.incu_custom_list.residentCustomerDataSource,
  loading: state.incu_custom_list.residentCustomerLoading,
}))(Form.create({ wrappedComponentRef: true })(TabEnter));



// WEBPACK FOOTER //
// ./src/components/incubator/custom/TableEnter.js